<div class="sidenav">
    <div class="logo-container">
        Profile Settings
    </div>
    <ul class="sidenav-nav">
        <li class="sidenav-item" *ngFor="let data of navData">
            <ng-container *ngIf="data.routeLink; else externalLink">
                <a class="sidenav-link" [routerLink]="[data.routeLink]" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <i class="sidenav-link-icon" [class]="data.icon"></i>
                    <span class="sidenav-link-text" *ngIf="!collapsed">{{ data.label }}</span>
                </a>
            </ng-container>
            <ng-template #externalLink>
                <!-- <a class="sidenav-link" href="#" (click)="openStripePortal()">
                    <i class="sidenav-link-icon" [class]="data.icon"></i>
                    <span class="sidenav-link-text" *ngIf="!collapsed">{{ data.label }}</span>
                </a> -->
                <a class="sidenav-link" href="#" (click)="openStripePortal($event)">
                    <i class="sidenav-link-icon" [class]="data.icon"></i>
                    <span class="sidenav-link-text" *ngIf="!collapsed">{{ data.label }}</span>
                </a>
            </ng-template>
        </li>
    </ul>
</div>